import { useEffect, useState } from 'react';

export function simpleHash(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
  }
  return hash;
}

export function getColor(str) {
    if (!str) return 'hsl(0, 60%, 80%)';
    const hash = simpleHash(str);
    const hue = Math.abs(hash % 360);
    return `hsl(${hue}, 60%, 80%)`;
}

export function getInitials(name = '') {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function drawNodePhotoFallback(ctx, node, size, color) {
  const initials = getInitials(node.name);
  ctx.fillStyle = color;
  ctx.fillRect(node.x - size / 2, node.y - size / 2, size, size);
  ctx.fillStyle = 'rgba(0, 0, 0, 0.72)';
  ctx.font = `700 ${Math.max(4.5, size * 0.42)}px Arial, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(initials, node.x, node.y + size * 0.02);
}

function getCoverCrop(img) {
  const sourceWidth = img.naturalWidth || img.width;
  const sourceHeight = img.naturalHeight || img.height;
  if (!sourceWidth || !sourceHeight) return null;

  const sourceRatio = sourceWidth / sourceHeight;
  const targetRatio = 1;
  if (sourceRatio > targetRatio) {
    const cropWidth = sourceHeight * targetRatio;
    return {
      sx: (sourceWidth - cropWidth) / 2,
      sy: 0,
      sw: cropWidth,
      sh: sourceHeight,
    };
  }

  const cropHeight = sourceWidth / targetRatio;
  return {
    sx: 0,
    sy: (sourceHeight - cropHeight) / 2,
    sw: sourceWidth,
    sh: cropHeight,
  };
}

export function drawNodePhoto(ctx, node, img, size, color) {
  ctx.save();
  ctx.beginPath();
  ctx.arc(node.x, node.y, size / 2, 0, 2 * Math.PI);
  ctx.clip();

  const imageReady = img && img.complete && img.naturalWidth > 0 && img.dataset.failed !== 'true';
  if (imageReady) {
    try {
      const crop = getCoverCrop(img);
      if (!crop) {
        drawNodePhotoFallback(ctx, node, size, color);
      } else {
        ctx.drawImage(
          img,
          crop.sx,
          crop.sy,
          crop.sw,
          crop.sh,
          node.x - size / 2,
          node.y - size / 2,
          size,
          size
        );
      }
    } catch (error) {
      drawNodePhotoFallback(ctx, node, size, color);
    }
  } else {
    drawNodePhotoFallback(ctx, node, size, color);
  }

  ctx.closePath();
  ctx.restore();
}

const useIsTouchscreen = () => {
  const [isTouchscreen, setIsTouchscreen] = useState(false);

  useEffect(() => {
    const handleTouchStart = () => {
      setIsTouchscreen(true);
      window.removeEventListener('touchstart', handleTouchStart);
    };

    window.addEventListener('touchstart', handleTouchStart);

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
    };
  }, []);

  return isTouchscreen;
};

export default useIsTouchscreen;
